import { useMutation } from '@tanstack/react-query';
import { updateGoal } from 'shared/services/backend-api';
import { UpdateGoal } from 'shared/types/goal';

export const useUpdateGoalMutation = () =>
  useMutation({
    mutationFn: async ({
      goal,
      forceValues,
    }: {
      goal: UpdateGoal;
      forceValues?: boolean;
    }) => updateGoal(goal, forceValues),
  });
